import {Params} from '@angular/router';

// import {PropsMapping} from '@shared/interfaces';
import {Model} from './model';
import {CategoryModel} from './category.model';
import {EventModel} from './event.model';

// const propsMapping: PropsMapping = {
const propsMapping: Params = {
  id: 'tournamentCategoryId',
  tournamentId: 'tournamentId',
  categoryId: 'categoryId',

  category: 'category',
  events: 'events',
};

export class TournamentCategoryModel extends Model {
  tournamentId!: number;
  categoryId!: number;

  category?: CategoryModel;
  events?: EventModel[];

  static getInstance(data: Params): TournamentCategoryModel {
    const model = new TournamentCategoryModel();
    for (const prop in propsMapping) {
      if (
        data[propsMapping[prop]] === undefined ||
        data[propsMapping[prop]] === null
      ) {
        continue;
      }

      if (prop === 'category') {
        (model as Params)[prop] = CategoryModel.getInstance(data[propsMapping[prop]]);
      } else if (prop === 'events') {
        if (Array.isArray(data[propsMapping[prop]])) {
          (model as Params)[prop] = data[propsMapping[prop]].map((item: Params): EventModel => {
            return EventModel.getInstance(item);
          });
        }
      } else {
        (model as Params)[prop] = data[propsMapping[prop]];
      }
    }

    if (!Array.isArray(model.events)) {
      model.events = [];
    }

    return model;
  }
}
